import { Badge } from '@customerio/pluma-components/react';
import type { SqlImport } from '@/services/db/sql-import/entity';
import { sqlImportStatusDetails } from '@/features/sql-sync';
import { epochNowInSeconds } from '@/utils/time';

type SyncStatusBadgeProps = {
  sqlImport: Pick<SqlImport, 'active' | 'is_draft' | 'start_at'>;
};

export function SyncStatusBadge({ sqlImport }: SyncStatusBadgeProps) {
  const { color, label } = sqlImportStatusDetails(sqlImport, epochNowInSeconds());
  return (
    <Badge color={color} showStatusIndicator data-test-sql-import-item-status>
      {label}
    </Badge>
  );
}
